export const TermsIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0229492" width="24.1283" height="23.2204" fill="white" />
    <path
      d="M18.4314 3.89307H6.70231C5.77691 3.89307 5.02673 4.71128 5.02673 5.7206V18.5133C5.02673 19.5227 5.77691 20.3409 6.70231 20.3409H18.4314C19.3568 20.3409 20.1069 19.5227 20.1069 18.5133V5.7206C20.1069 4.71128 19.3568 3.89307 18.4314 3.89307Z"
      stroke="#8090A9"
      strokeWidth="1.26079"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37787 7.5481H16.7558"
      stroke="#8090A9"
      strokeWidth="1.26079"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37787 12.1169H16.7558"
      stroke="#8090A9"
      strokeWidth="1.26079"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37787 16.6858H13.4046"
      stroke="#8090A9"
      strokeWidth="1.26079"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
